import { AddQsrXrefModalProps } from './QsrModal.types';
import Modal from '../../../components/Modal/Modal';
import { DropdownWrapper } from '../QsrDept.styles';
import Dropdown from '../../../components/Dropdown/Dropdown';
import { StyledButtons } from '../../RawProdGINs/RawProdGins.style';
import Button from '../../../components/Button/Button';
import { Variant } from '../../../components/Button/Button.types';
import React from 'react';
import { RowWrapper } from '../../OptionRecipes/ChangeUsage/ChangeUsage.styles';

export const RemoveQsrDeptMasterModal = ({
                                           open,
                                           onClose,
                                           onCancel,
                                           onConfirm,
                                           isDisabled,
                                           classOptions,
                                           baseOptions,
                                           sizeOptions,
                                           productOptions,
                                           selectedClassToAddQsrXref,
                                           selectedQsrDeptMaster,
                                           handleClassSelect,
                                           selectedBase,
                                           handleBaseSelect,
                                           selectedSize,
                                           handleSizeSelect,
                                           selectedProduct,
                                           handleProductSelect,
                                           validateSelections,
                                         }: AddQsrXrefModalProps): JSX.Element => {
  return (
    <Modal
      id="addNewQsrDeptXrefModal"
      open={open}
      onClose={onClose}
      title={`Add new QsrXref for Department: ${selectedQsrDeptMaster?.id} ~ ${selectedQsrDeptMaster?.description}`}
    >
      <div>
        <RowWrapper>
          <DropdownWrapper>
            <Dropdown
              id="moaClassToQsrXref"
              label="Class"
              options={classOptions}
              value={selectedClassToAddQsrXref?.toString()}
              onChange={handleClassSelect}
              optionsPlaceholder="Select Class"
              disabled={false}
              dataTestId={'AddXrefClassDropdown'}
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Dropdown
              id="moaBaseNo"
              label="Base"
              options={[{ value: undefined, label: '' }, ...baseOptions]}
              value={selectedBase?.toString()}
              onChange={handleBaseSelect}
              hidePlaceholder={true}
              disabled={isDisabled}
              dataTestId={'BaseDropdown'}
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Dropdown
              id="moaSizeNo"
              label="Size"
              options={[{ value: undefined, label: '' }, ...sizeOptions]}
              value={selectedSize?.toString()}
              onChange={handleSizeSelect}
              hidePlaceholder={true}
              disabled={isDisabled}
              dataTestId={'SizeDropdown'}
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Dropdown
              id="moaProdNo"
              label="Product"
              options={[{ value: undefined, label: '' }, ...productOptions]}
              value={selectedProduct?.toString()}
              onChange={handleProductSelect}
              hidePlaceholder={true}
              disabled={isDisabled}
              dataTestId={'ProductDropdown'}
            />
          </DropdownWrapper>
        </RowWrapper>
        <StyledButtons>
          <Button variant={Variant.Secondary} label="Cancel" testId={'AddNewXrefCloseButton'}
                  onClick={onCancel} />
          <Button label="Ok" onClick={onConfirm} testId={'AddNewXrefConfirmButton'}
                  disabled={validateSelections()} />
        </StyledButtons>
      </div>
    </Modal>
  );
};

export default RemoveQsrDeptMasterModal;
